import Loader from './loader';

export default class PasswordRecovery {
    constructor($form) {
        this.$form = $form;
        this.$email = $form.querySelector('#recovery-email');
        this.loader = (new Loader($form.querySelector('[data-loader]')));

        this.submit = this.submit.bind(this);
        this.fetch = this.fetch.bind(this);

        this.$form.addEventListener('submit', this.submit);
    }

    async submit(e) {
        e.preventDefault();


        if (! this.$email.value) {
            return false;
        }

        // validate email
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(this.$email.value)) {
            let div = document.createElement("div");
            div.innerHTML = '<div class="form__error form__error--general">Dit is geen geldig e-mail adres...</div>';
            this.$form.prepend(div)
            return false;
        }

        if(this.$form.querySelector('.form__error')) {
            this.$form.querySelector('.form__error').remove();
        }

        this.loader.loading(true);

        const result = await this.fetch();
        this.loader.loading(false);

        if (result.success === true) {
            let div = document.createElement("div");
            div.innerHTML = '<strong class="alert alert-success text--color-1">We hebben de nodige instructies naar je mailbox gestuurd.</strong>'
            this.$form.prepend(div)
        }
    }

    async fetch() {
        const body = JSON.stringify({
            email: this.$email.value,
        });

        try {
            const request = await fetch(
                    placeholders.baseUri
                            ? placeholders.baseUri + '/ajax-data/account/password-forgotten'
                            : 'ajax-data/account/password-forgotten',
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: body
                    }
            );
            const result = await request.json();
            return result;
        } catch (e) {
            console.log(e);
        }
    }
}